export default __webpack_public_path__ + "static/media/Dagger of the Archaeologian.582a28cc.jpg";